import * as React from "react";
const CoordinatedAssessementIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 56 56",
  "aria-hidden": "true",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M44.605 29.474a2.917 2.917 0 0 0 0-2.94 19.224 19.224 0 0 0-33.2 0 2.917 2.917 0 0 0 0 2.94 19.22 19.22 0 0 0 33.2 0Zm-16.6 4.53a6 6 0 1 1 0-12 6 6 0 0 1 0 12Zm12.5-17h10a1.5 1.5 0 1 0 0-3h-6.38l7.414-7.414a1.5 1.5 0 1 0-2.12-2.121l-7.414 7.414V5.504a1.5 1.5 0 0 0-3 0v10a1.5 1.5 0 0 0 1.5 1.5Zm-36.5-1.5a1.5 1.5 0 0 0 1.5 1.5h10a1.5 1.5 0 0 0 1.5-1.5v-10a1.5 1.5 0 0 0-3 0v6.379L6.592 4.469a1.5 1.5 0 0 0-2.121 2.12l7.413 7.415h-6.38a1.5 1.5 0 0 0-1.5 1.5Zm48 25a1.5 1.5 0 0 0-1.5-1.5h-10a1.5 1.5 0 0 0-1.5 1.5v10a1.5 1.5 0 1 0 3 0v-6.379l7.413 7.414a1.5 1.5 0 1 0 2.12-2.12l-7.412-7.415h6.379a1.5 1.5 0 0 0 1.5-1.5Zm-36.5-1.5h-10a1.5 1.5 0 1 0 0 3h6.38L4.47 49.418a1.5 1.5 0 1 0 2.12 2.121l7.415-7.414v6.379a1.5 1.5 0 1 0 3 0v-10a1.5 1.5 0 0 0-1.5-1.5Z"
}));
export default CoordinatedAssessementIcon;